import { getTenantOutstandingColumns, getTenantOutstandingRows } from "./tenant-outstanding-statement";
import { AgingSummary } from "./aging-statement";
import { getTenantOutstanding, getTenantOutstandingSummary } from "@/api/finance/reportApi";
import {
  DynamicReport
} from "@/components/dynamic";
import { formatApiPayloadDate } from "@/utils/helpers";

const tenantOutstandingFilters = {
  TenantName: "*",
  TenantNumber: "*",
  InvoiceNumber: "*",
  ComponentNumber: "*",
  ContractNumber: "*",
  TransactionDate: formatApiPayloadDate(new Date()),
};

const tenantOutstandingFilterOptions = [
  { key: "tenantName", apiKey: "TenantName", keyType: "label" },
  { key: "componentNumber", apiKey: "ComponentNumber", keyType: "number" },
  { key: "contractNumber", apiKey: "ContractNumber", keyType: "label" },
  { key: "tenantNumber", apiKey: "TenantNumber", keyType: "label" },
  { key: "invoiceNumber", apiKey: "InvoiceNumber", keyType: "string" },
  { key: "transactionDate", apiKey: "TransactionDate", keyType: "date" },
];

// Totals over every line that matches the filters, not just the page
// (TenantOutstandingSummaryReport).
const summaryTiles = [
  { key: "netBalanceTotal", label: "Net Outstanding", highlight: true },
  { key: "balanceTotal", label: "Balance" },
  { key: "pdcTotal", label: "PDCs" },
  { key: "lines", label: "Lines", isCount: true },
  { key: "tenants", label: "Tenants", isCount: true },
  { key: "amountTotal", label: "Invoice Amount" },
  { key: "collectedTotal", label: "Collected" },
];

export default function ReportTenantOutstanding({ activeCompany }) {
  return (
    <DynamicReport
      reportName="tenant-outstanding"
      activeCompany={activeCompany}
      columnsDataProvider={getTenantOutstandingColumns}
      rowsDataProvider={getTenantOutstandingRows}
      fetchData={getTenantOutstanding}
      fetchSummary={getTenantOutstandingSummary}
      renderSummary={(summary) => <AgingSummary summary={summary} tiles={summaryTiles} />}
      exportUrl="leasing/reports/tenant-outstanding/xls"
      filtersInitialState={tenantOutstandingFilters}
      filterOptions={tenantOutstandingFilterOptions}
      showDateRangeFilter={false}
      orderBy="TenantNumber"
    />
  );
}
